export enum FranchisorPhoneTypeEnum {
  COMMON = 'COMMON',
  FAX = 'FAX',
  OTHER = 'OTHER',
}
